import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Authorizations() {
  return <V20Embed view="authorizations" testid="authorizations-view" />;
}
